export default "__VITE_ASSET__2bb0b745__"